import {
  PET_CHANGE,
  PET_SELECTED,
  PET_DROPFILES
} from '../../actions';

const newPet = {
  name: '',
  species: '',
  gender: '',
  description: '',
  image: '',
  castrated: '',
};

const petReducer = (
  oldState = {
    petVm: newPet
  },
  action,
) => {
  const { petVm } = oldState;

  switch (action.type) {
    case PET_CHANGE: {
      const { name, value } = action;
      return {
        ...oldState,
        petVm: {
          ...petVm,
          [name]: value,
        },
      };
    }
    case PET_DROPFILES:
      return {
        ...oldState,
        petVm: {
          ...petVm,
          image: action.secureUrl,
        },
      };
    case PET_SELECTED:
      return {
        ...oldState,
        petVm: (action.response && { ...action.response.data(), id: action.response.id }) || newPet,
      };
    default:
      return oldState;
  }
};

export default petReducer;



// WEBPACK FOOTER //
// ./src/pages/Pet/petReducer.js